export const REQUEST_MESSAGES = 'conversations/REQUEST_MESSAGES';
export const REQUEST_CONVERSATION_LIST = 'conversations/REQUEST_CONVERSATION_LIST';
export const REQUEST_UNREAD_COUNT = 'conversations/UNREAD_COUNT';
export const REQUEST_UNREAD_CATEGORIES = 'conversations/REQUEST_UNREAD_CATEGORIES';
export const REQUEST_MARK_READ_MESSAGES = 'conversations/REQUEST_MARK_READ_MESSAGES';
